import { postTradeOperationsApiConnecter } from 'apiConnector/post-trade-operations';
import { BlotterItemType } from 'models/blotters/BlotterType';
import { ofType } from 'redux-observable';
import type { Observable } from 'rxjs';
import { of } from 'rxjs';
import { catchError, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import type { EpicWithThunk } from 'state/state.common';
import {
  tradeCancellationFailed,
  tradeCancellationRejected,
  tradeCancelled,
} from 'state/trades/cancellations/cancellations.actions';
import { getTradeCancellation } from 'state/trades/cancellations/cancellations.selectors';
import { toApiError } from 'utils/http/apiErrorHelper';

export interface TradeCancellationApi {
  cancelTrade(tradeId: string, itemType?: BlotterItemType, isin?: string): Observable<unknown>;
}

export function tradeCancellationRequestedEpic(): EpicWithThunk {
  return (actions$, state$, { httpClient }) =>
    actions$.pipe(
      ofType('TRADE_CANCELLATION_REQUESTED'),
      withLatestFrom(state$),
      mergeMap(([{ tradeId, isin }, state]) => {
        const tradeCancellation = getTradeCancellation(state, tradeId);

        return postTradeOperationsApiConnecter(httpClient)
          .cancelTrade(tradeId, tradeCancellation?.blotterItem.blotterItemType, isin)
          .pipe(
            map(() => {
              if (tradeCancellation?.blotterItem.blotterItemType === 'DlpProductTrade') {
                return tradeCancelled(tradeId, tradeCancellation.blotterItem.productIsin);
              }
              return tradeCancelled(tradeId);
            }),
            catchError(error => {
              return error?.status === 400 || error?.status === 504
                ? of(tradeCancellationRejected(tradeId, toApiError(error)))
                : of(tradeCancellationFailed(tradeId));
            }),
          );
      }),
    );
}
